export const PERCENTAGE_METRICS = {
  conversionRate: true,
  advertisingCostOfSale: true,
  avgIncrementality: true,
  clickThroughRate: true
};
